<!-- 中奖弹窗 -->
<template>
  <div class="winning-popup">
    <van-overlay :show="show" @click="close" :lock-scroll="false">
      <div class="wrapper" @click.stop>
        <div class="top">
          <img
            v-if="topShow"
            class="img"
            :src="require(`@/assets/imgs/xiameBankNewGuestsHaveGifts/ptop.png`)"
            alt=""
          />
        </div>

        <div class="p-bg">
          <p class="text" v-html="msg"></p>
          <div class="btn" @click="close">{{ btnText }}</div>
        </div>
      </div>
      <img
        class="close"
        @click="close"
        :src="require(`@/assets/imgs/xiameBankNewGuestsHaveGifts/close.png`)"
        alt=""
      />
    </van-overlay>
  </div>
</template>
<script>
export default {
  components: {},
  data() {
    return {
      show: false,
      msg: '',
      topShow: false,
      btnText: ''
    }
  },
  created() {
    // this.open(2)
  },
  methods: {
    open(type, message) {
      this.topShow = true
      switch (type) {
        case 0:
          this.msg = `您不符合活动资格\n请关注其他活动`;
          this.btnText = `知道了`;
          this.topShow = false
          break;
        case 1:
          this.msg = `恭喜您获得一次抽奖机会`;
          this.btnText = `去抽奖`;
          break;
        case 2:
          this.msg = `恭喜您获得<span style="color:red;">${message}</span>元立减金！`;
          this.btnText = `开心收下`;
          break;
        case 3:
          this.msg = `很遗憾，您没有中奖！`;
          this.btnText = `好的`;
          break;
        default:
          this.msg = message;
          this.btnText = `知道了`;
          this.topShow = false
          break;
      }
      this.show = true
    },
    close() {
      this.setShow(false)
      this.$emit('prizesClose')
    },
    setShow(val) {
      this.show = val
    },
  },
}
</script>
<style lang="less" scoped>
.winning-popup {
  position: relative;
  text-align: center;

  .wrapper {
    margin: 120px auto 20px auto;
    width: 287px;
    text-align: center;
    .top {
      margin: auto;
      width: 228px;
      height: 95px;
      .img {
        width: 100%;
      }
    }
    .p-bg {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      margin-top: -1px;
      box-sizing: border-box;
      padding: 20px;
      height: 230px;
      background: url("../../../../assets/imgs/xiameBankNewGuestsHaveGifts/pbg.png")
        no-repeat;
      background-size: 100% auto;
    }
    .text {
      margin-top: 15px;
      font-size: 16px;
      color: #000000;
      line-height: 1.5;
      white-space: pre-line;
    }
    .btn {
      margin-top: 51px;
      width: 170px;
      height: 44px;
      background: url("../../../../assets/imgs/xiameBankNewGuestsHaveGifts/btn.png")
        no-repeat;
      background-size: 100% auto;
      font-weight: 800;
      font-size: 21px;
      color: #ffffff;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
  .close {
    width: 32px;
  }
}
</style>
